import DescriptionMapper from './description-mapper';
import MainMarketDescriptionModel from '../main-market-description/main-market-description-model';
import MarketDescriptionModel from '../market-description/market-description-model';
import OutcomeDescriptionModel from '../outcome-description/outcome-description-model';
import SpecifierDescriptionModel from '../specifier-description/specifier-description-model';

const DescriptionModel = {
    mapper: DescriptionMapper,

    mainMarkets: {
        model: MainMarketDescriptionModel,
        type: Array,
    },

    markets: {
        model: MarketDescriptionModel,
        type: Array,
    },

    outcomes: {
        model: OutcomeDescriptionModel,
        type: Array,
    },

    specifiers: {
        model: SpecifierDescriptionModel,
        type: Array,
    },
};

export default DescriptionModel;
